// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { ReviewReviewFragmentDoc } from '../../__generated-gql-types__/Review.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReviewModalReviewFragment = {
  __typename?: 'Review';
  id: string;
  anonymous: boolean;
  rate: number;
  overallRate: number;
  headline?: string | null;
  comment?: string | null;
  guestReviewer?: string | null;
  reviewedAt: number;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  };
  categoryReviews?: Array<{
    __typename?: 'CategoryReview';
    responsiveness?: number | null;
    supportiveness?: number | null;
    knowledge?: number | null;
    value?: number | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      isFeatured: boolean;
      goal: Types.GoalName;
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
      }> | null;
    };
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      name: string;
    }> | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'JobOfferInfo';
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        };
      }
    | {
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }
    | { __typename?: 'TestScoreV2'; score: number; testName: string }
  > | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    id: string;
    classOrder?: {
      __typename?: 'ClassOrder';
      coachingSession: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename: 'BootcampSession' }
          | { __typename: 'Class'; id: string; name?: string | null }
          | { __typename: 'EventSession' }
          | { __typename: 'OneOnOneSession' };
      };
    } | null;
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      visibility: Types.PackageVisibility;
      category?: { __typename?: 'Category'; id: string; name: string } | null;
    } | null;
  } | null;
  mostRecentClassSession?: {
    __typename?: 'CoachingSession';
    id: string;
    content:
      | { __typename: 'BootcampSession' }
      | {
          __typename: 'Class';
          id: string;
          name?: string | null;
          isFreeEvent?: boolean | null;
        }
      | { __typename: 'EventSession' }
      | { __typename: 'OneOnOneSession' };
  } | null;
};

export type ReviewModalDeleteReviewMutationVariables = Types.Exact<{
  id: Types.Scalars['ReviewUrn']['input'];
}>;

export type ReviewModalDeleteReviewMutation = {
  __typename?: 'Mutation';
  deleteReview: boolean;
};

export const ReviewModalReviewFragmentDoc = gql`
  fragment ReviewModal_Review on Review {
    ...Review_Review
  }
  ${ReviewReviewFragmentDoc}
`;
export const ReviewModalDeleteReviewDocument = gql`
  mutation ReviewModal_DeleteReview($id: ReviewUrn!) {
    deleteReview(id: $id)
  }
`;
export type ReviewModalDeleteReviewMutationFn = Apollo.MutationFunction<
  ReviewModalDeleteReviewMutation,
  ReviewModalDeleteReviewMutationVariables
>;

/**
 * __useReviewModalDeleteReviewMutation__
 *
 * To run a mutation, you first call `useReviewModalDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewModalDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewModalDeleteReviewMutation, { data, loading, error }] = useReviewModalDeleteReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReviewModalDeleteReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviewModalDeleteReviewMutation,
    ReviewModalDeleteReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReviewModalDeleteReviewMutation,
    ReviewModalDeleteReviewMutationVariables
  >(ReviewModalDeleteReviewDocument, options);
}
export type ReviewModalDeleteReviewMutationHookResult = ReturnType<
  typeof useReviewModalDeleteReviewMutation
>;
export type ReviewModalDeleteReviewMutationResult =
  Apollo.MutationResult<ReviewModalDeleteReviewMutation>;
export type ReviewModalDeleteReviewMutationOptions = Apollo.BaseMutationOptions<
  ReviewModalDeleteReviewMutation,
  ReviewModalDeleteReviewMutationVariables
>;
